module.exports = __webpack_public_path__ + "media/img/vca/prizes/human-06470b046a45b5150e616ab6080661fd.png";